import React from "react";
import { MotifTooltip } from "../../../assets/lib/motif";

export function Tooltip({ trigger, variant, tooltipText }) {
  return (
    <MotifTooltip
      trigger={trigger}
      variant={variant}
      allowClick="false"
      allowHover="true"
      flip="true"
      hideCloseButton="true"
    >
      {tooltipText}
    </MotifTooltip>
  );
}
